export const PATHNAMES = {
  AUTH: "/auth",
  LOGIN: "/login",
  REGISTRATION: "/auth/registration",
  GOOGLE_AUTH: "/auth/google",

  HOME: "/",

  CLONES: "/clones",
  CLONE_ITEM: "/clones/:slug",

  INQUIRIES: "/inquiries",
  INQUIRY_ITEM: "/inquiries/:slug",

  ABOUT_US: "/about-us",
  OPPORTUNITIES: "/opportunities",
  CONTACT_US: "/feedback",
  COOKIE_POCILY: "/cookie-policy",

  BLOG: "/blog",
  BLOG_ITEM: "/blog/:slug",

  CABINET: "/cabinet",
  CHAT: "/cabinet/chat",
  CHAT_ITEM: "/cabinet/chat/:id",
  FAVORITES_CLONES: "/cabinet/favorites",
  MY_CLONES: "/cabinet/my-clones",
  CREATE_CLONE: "/cabinet/my-clones/create",
  EDIT_CLONE: "/cabinet/my-clones/:slug/edit",
  DEALS: "/cabinet/deals",
  DEAL_ITEM: "/cabinet/deals/:deal",
  // CHANGE
  MODERATING_DEALS: "/cabinet/deals-moderating",

  ACCOUNT: "/cabinet/account",
  SETTINGS: "/cabinet/settings",

  FAVOURITE_INQUIRIES: "/cabinet/watchlist",
  MY_INQUIRIES: "/cabinet/my-inquiries", // only for agent (broker)
  CREATE_INQUIRY: "/cabinet/my-inquiries/create", // only for agent (broker)
  EDIT_INQUIRY: "/cabinet/my-inquiries/:slug/edit", // only for agent (broker)

  USERS: "/users",
  USER_PROFILE: "/users/:id",
  USER_PROFILE_CLONES: "/users/:id/clones",
  USER_PROFILE_INQUIRIES: "/users/:id/inquiries", // only for agent (broker)

  PRIVE_POLICY: "/privacy-policy",
  TERMS_OF_USE: "/terms-of-use",

  NOT_FOUND: "/*",
} as const;
